import { render, staticRenderFns } from "./EventFilterMenuProduct.vue?vue&type=template&id=5118fbc5"
import script from "./EventFilterMenuProduct.vue?vue&type=script&lang=js"
export * from "./EventFilterMenuProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports